import { SwiperSlide } from 'swiper/react'
import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  width: 100%;
  position: relative;
  padding-left: 32px;
`

export const Slide = styled(SwiperSlide)`
  width: auto;
  padding-bottom: 8px;
`

export const BaseButton = styled(Box)`
  width: 56px;
  height: 56px;
  position: absolute;
  top: calc(50% - 32px);
  z-index: 20;
  border-radius: 4px;
  opacity: 0.2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(212, 215, 234, 0.6);
  cursor: pointer;

  &:hover {
    transition: all ease 0.3s;
    opacity: 0.8;
  }
`

export const LeftButton = styled(BaseButton)`
  left: 0;
`

export const RightButton = styled(BaseButton)`
  right: 0;
`
